module.exports = __webpack_public_path__ + "static/booklist2.10fefed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/booklist2.jpg
// module id = 338
// module chunks = 35783957827783